import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_ea_war } from '../zps';

export interface IRegionResponse extends ApiResponse {
  regions: string[];
}

export const fetchRegions = (): Promise<AxiosResponse<IRegionResponse>> => {
  return axios.get<IRegionResponse>(`${zps_ea_war}/region`);
};
